<section [class]="'page-header ' + (classes ? classes : '')  + backgrounds[game]">
    <app-bokeh *ngIf="game !== 'valorant'"></app-bokeh>
    <div class="container" *ngIf="title">
        <h1 class="text-center text-bj pb-r2 title">{{ title }}</h1>
    </div>
    <ng-content></ng-content>
</section>
